import { __ } from '@wordpress/i18n';
import { useState, useEffect } from '@wordpress/element';
import DemoCardsLoader from './DemoCardsLoader';

const fetchDemoCards = async () => {
	try {
		const response = await fetch(
			'https://selfservice.dokandemo.com/api/demo-types'
		);
		const data = await response.json();
		return data;
	} catch ( error ) {
		return [];
	}
};

const DemoCards = () => {
	const [ demoCards, setDemoCards ] = useState( [] );
	const [ isLoading, setIsLoading ] = useState( false );
	const [ error, setError ] = useState( null );
	const [ modalOpen, setModalOpen ] = useState( false );
	const [ selectedEmbedUrl, setSelectedEmbedUrl ] = useState( '' );

	useEffect( () => {
		setIsLoading( true );
		fetchDemoCards()
			.then( ( data ) => setDemoCards( data ) )
			.catch( setError )
			.finally( () => setIsLoading( false ) );
	}, [] );

	const openModal = ( embedUrl ) => {
		setSelectedEmbedUrl( embedUrl );
		setModalOpen( true );
		document.body.style.overflow = 'hidden';
	};

	const closeModal = () => {
		setModalOpen( false );
		setSelectedEmbedUrl( '' );
		document.body.style.overflow = '';
	};

	const handleOverlayClick = ( e ) => {
		if ( e.target === e.currentTarget ) {
			closeModal();
		}
	};

	useEffect( () => {
		const handleEscape = ( e ) => {
			if ( e.key === 'Escape' && modalOpen ) {
				closeModal();
			}
		};

		document.addEventListener( 'keydown', handleEscape );
		return () => document.removeEventListener( 'keydown', handleEscape );
	}, [ modalOpen ] );

	if ( isLoading ) {
		return (
			<>
				<DemoCardsLoader />
				<DemoCardsLoader />
				<DemoCardsLoader />
				<DemoCardsLoader />
				<DemoCardsLoader />
				<DemoCardsLoader />
			</>
		);
	}

	if ( error ) {
		return <div>Error: { error }</div>;
	}

	return (
		<>
			{ demoCards.map( ( card ) => (
				<div className="wp-block-do-blocks-demo-card" key={ card.id }>
					{ card.image && (
						<a href={ card.permalink } className="demo-card-image">
							<img src={ card.image } alt={ card.name } />
						</a>
					) }
					<div className="demo-card-content">
						<div className="demo-card-content-header">
							<h3>
								<a href={ card.permalink }>{ card.name }</a>
							</h3>
							<p>{ __( 'Marketplace Demo', 'do-blocks' ) }</p>
						</div>
						<p>{ card.description }</p>
					</div>
					<div className="demo-card-try-demo-btn-container">
						<button
							onClick={ () => openModal( card.embed_url ) }
							className="demo-card-try-demo-btn"
						>
							{ __( 'Try Demo', 'do-blocks' ) }
						</button>
					</div>
				</div>
			) ) }

			{ modalOpen && (
				<div
					className="demo-modal-overlay"
					onClick={ handleOverlayClick }
					onKeyDown={ ( e ) => {
						if ( e.key === 'Enter' || e.key === ' ' ) {
							closeModal();
						}
					} }
					role="button"
					tabIndex={ 0 }
					aria-label={ __( 'Close modal overlay', 'do-blocks' ) }
				>
					<div
						className="demo-modal-content"
						role="dialog"
						aria-modal="true"
					>
						<button
							className="demo-modal-close"
							onClick={ closeModal }
							aria-label={ __( 'Close modal', 'do-blocks' ) }
						>
							&times;
						</button>
						<iframe
							src={ selectedEmbedUrl }
							className="demo-modal-iframe"
							title={ __( 'Demo Preview', 'do-blocks' ) }
						/>
					</div>
				</div>
			) }
		</>
	);
};

export default DemoCards;
